import { Heading, Text } from "@instacover/ui"

import NotFoundIcon from "@/assets/icons/NotFound.svg?react"

export function NotFound() {
  return (
    <main className="flex w-full grow flex-col justify-between">
      <div className="text-ic-primary flex items-center justify-center px-9 py-6">
        <NotFoundIcon className="h-auto max-h-[40dvh] w-full max-w-md" />
      </div>

      <div className="mt-6 mb-9 grow px-9">
        <Heading as="h1" variant="h2" className="text-ic-primary mb-5 uppercase">
          Neplatný odkaz
        </Heading>

        <Text>Pro vstup do aplikace použijte unikátní odkaz, který vám vygenerovala vaše pojišťovna.</Text>
      </div>
    </main>
  )
}
